import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	header: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	description: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	project: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	board: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	serviceProject: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	filter: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	dashboard: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	plan: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	projectGalaxia: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	serviceProjectGalaxia: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	header: {
		defaultMessage: 'Star your work for quick access',
		id: 'home.tabs.starred.empty-state.header',
		description: 'Empty State header for jira home starred tab',
	},
	description: {
		defaultMessage: 'Get started by finding your',
		id: 'home.tabs.starred.empty-state.description',
		description: 'Empty State description for jira home starred tab',
	},
	project: {
		defaultMessage: 'Project',
		id: 'home.tabs.starred.empty-state.project',
		description: 'button label to go to Projects',
	},
	board: {
		defaultMessage: 'Board',
		id: 'home.tabs.starred.empty-state.board',
		description: 'button label to go to Boards',
	},
	serviceProject: {
		id: 'home.tabs.starred.empty-state.service-project',
		defaultMessage: 'Service project',
		description: 'button label to go to service project',
	},
	filter: {
		defaultMessage: 'Filter',
		id: 'home.tabs.starred.empty-state.filter',
		description: 'button label to go to Filters',
	},
	dashboard: {
		defaultMessage: 'Dashboard',
		id: 'home.tabs.starred.empty-state.dashboard',
		description: 'button label to go to Dashboards',
	},
	plan: {
		defaultMessage: 'Plan',
		id: 'home.tabs.starred.empty-state.plan',
		description: 'button label to go to Plans',
	},
	projectGalaxia: {
		defaultMessage: 'Space',
		id: 'home.tabs.starred.empty-state.project-galaxia',
		description: 'button label to go to Projects',
	},
	serviceProjectGalaxia: {
		id: 'home.tabs.starred.empty-state.service-project-galaxia',
		defaultMessage: 'Service space',
		description: 'button label to go to service project',
	},
});
export default messages;
